import GuestCheckout from "./guests";

export default GuestCheckout;
